import { Navigate, Route, Routes } from 'react-router-dom';
import { ScrollToTop } from '@/components/ScrollToTop';
import { LEGACY_PATHS, ROUTES } from '@/constants/site';
import IndexPage from '@/pages/index/IndexPage';
import PlanPage from '@/pages/plan/PlanPage';
import DemoPage from '@/pages/demo/DemoPage';
import InquiryPage from '@/pages/inquiry/InquiryPage';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path={ROUTES.index} element={<IndexPage />} />
        <Route path={ROUTES.plan} element={<PlanPage />} />
        <Route path={ROUTES.demo} element={<DemoPage />} />
        <Route path={ROUTES.inquiry} element={<InquiryPage />} />

        {/* 옛 정적 페이지 주소로 들어와도 살린다 (서버 301 이 없을 때의 안전망) */}
        {Object.entries(LEGACY_PATHS).map(([from, to]) => (
          <Route key={from} path={from} element={<Navigate to={to} replace />} />
        ))}

        <Route path="*" element={<Navigate to={ROUTES.index} replace />} />
      </Routes>
    </>
  );
}
